import axios from "axios";
import { config } from '../config.env'

const platform = config.PLATFORM;
const endpoint = config.ENDPOINT;
const AI_ENDPOINT = config.AI_API_ENDPOINT;

export function getHealthATMResult(pid) {

    const encodedCred = `c29ua2E6c29ua2FATVU=`;

    return new Promise(resolve => {
        const url = `http://103.164.85.26:5511/get_vs_by_pid/${pid}`;
        const header = {
            'Authorization': `Basic ${encodedCred}`,
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function getHealthATMResultOmnix(pid) {

    return new Promise(resolve => {
        const url = `${AI_ENDPOINT}/healthConnect/sonka/vitals/read?pid=${pid}`;
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function getIoTsResult() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/healthStation/point-of-Care/findResult`;
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function getBloodTestResult() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/healthStation/point-of-Care/findBloodResult`;
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function getSmartWatch() {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/healthStation/point-of-Care/smartwatch/findHealthRecord`;
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}

export function getSmartWatchRecords(field, from, to) {

    return new Promise(resolve => {
        const url = `${endpoint}/health-atm/healthStation/point-of-Care/smartwatch/findHealthRecordList?field=${field}&date_from=${from}&date_to=${to}`;
        const header = {
            'Platform': platform,
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        };
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        });
    });
}